import React from "react";

export class ButtonFabMenuModel {
    constructor (
        public icon: JSX.Element,
        public tittle: string,
        public onClick: React.MouseEventHandler<HTMLDivElement>,
    ) {}
}